<template>
  <nav
    class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" :textWhite="textWhite" />
      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="this.$store.state.isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar"
      >
        <div
          class="pe-md-3 d-flex align-items-center"
          :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'"
        >
          <div class="input-group"></div>
        </div>
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item d-flex align-items-center">
            <div class="dropdown portal-account-dropdown" ref="accountMenu" @keydown.esc.stop="closeAccountMenu">
              <button type="button" class="nav-link dropdown-toggle portal-account-toggle" id="userDropdown" aria-controls="portal-account-actions" :aria-expanded="userMenuOpen" :disabled="signingOut" @click.stop="userMenuOpen = !userMenuOpen">
                <img
                  :src="avatarUrl"
                  :alt="$t(&quot;User Avatar&quot;)"
                  class="rounded-circle"
                  width="60"
                  height="60"
                />
              </button>
              <ul v-show="userMenuOpen" id="portal-account-actions" class="dropdown-menu show" aria-labelledby="userDropdown">
                <li>
                  <button type="button" class="dropdown-item" :disabled="signingOut" @click.stop="signout"
                    ><portal-text message="Sign Out" :help="false" /></button
                  >
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="#"
                    @click="closeAccountMenu" data-bs-toggle="modal"
                    data-bs-target="#switchClientModal"
                  >
                    <portal-text message="Switch Client" :help="false" />
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
              href="#"
              @click="toggleSidebar"
              class="p-0 nav-link text-body"
              id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div
    class="modal fade"
    id="switchClientModal"
    tabindex="-1"
    aria-labelledby="switchClientModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="switchClientModalLabel"><portal-text message="Switch Client" /></h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(&quot;Close&quot;)"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div
              v-for="client in clients"
              :key="client.id"
              class="col-12 col-md-6 col-lg-4 mb-3"
            >
              <button
                class="btn btn-primary w-100"
                @click="
                  selectClient(
                    client.client_id,
                    client.client.first_name,
                    client.client.last_name
                  )
                "
              >
                {{ client.client.first_name }} {{ client.client.last_name }}
              </button>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            <portal-text message="Close" :help="false" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { signOutPortal } from '@/auth/portalSession';
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapActions } from "vuex";
import Swal from "sweetalert2";
import { isPublicAuthPath } from "@/utils/publicAuthRoutes";

export default {
  name: "navbar",
  data() {
    return {
      userMenuOpen: false, signingOut: false,
      avatarUrl: "favicon.png",
      clients: [],
    };
  },
  props: ["minNav", "textWhite"],
  methods: {
    updateNavbarOnScroll() {
      const navbar = document.getElementById('navbarBlur');
      if (!navbar) return;
      const fixed = window.scrollY > 10 && this.$store.state.isNavFixed;
      for (const name of ['blur', 'position-sticky', 'shadow-blur']) navbar.classList.toggle(name, Boolean(fixed));
    },
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),
    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    closeAccountMenu() { this.userMenuOpen = false; },
    closeAccountMenuOutside(event) { if (!this.$refs.accountMenu?.contains(event.target)) this.closeAccountMenu(); },
    async signout() {
      if (this.signingOut) return;
      this.signingOut = true; this.closeAccountMenu();
      try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will be signed out!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, sign me out!",
      });
      if (result.isConfirmed) {
        const logout = await signOutPortal('employee');
        if (logout.signedOut) await this.$router.replace({ name: "Sign In" });
      }
      } finally { this.signingOut = false; }
    },
    fetchClients() {
      const token = localStorage.getItem("token");
      if (!token) return;
      if (isPublicAuthPath(this.$route.path)) return;

      fetch(`${process.env.VUE_APP_BACKEND_DOMAIN}/api/client_fetch`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then(async (response) => {
          if (!response.ok) return;
          const data = await response.json();
          if (data && Array.isArray(data.clients)) {
            this.clients = data.clients;
          }
        })
        .catch((error) => {
          console.error("Error fetching clients:", error);
        });
    },
    selectClient(clientId, clientName, clientLastName) {
      localStorage.setItem("selectedClientId", clientId);
      localStorage.setItem("clientName", clientName);
      localStorage.setItem("clientLastName", clientLastName);
      location.reload();
    },
  },
  components: {
    Breadcrumbs,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  mounted() {
    document.addEventListener('pointerdown', this.closeAccountMenuOutside);
    window.addEventListener('scroll', this.updateNavbarOnScroll, { passive: true });
    this.updateNavbarOnScroll();
    if (isPublicAuthPath(this.$route.path)) return;
    if (!localStorage.getItem("token")) return;
    this.fetchClients();
  },
  beforeUnmount() {
    document.removeEventListener('pointerdown', this.closeAccountMenuOutside);
    window.removeEventListener('scroll', this.updateNavbarOnScroll);
  },
};
</script>

<style scoped>
.portal-account-dropdown { position:relative; }
.portal-account-toggle { border:0; background:transparent; }
.portal-account-dropdown .dropdown-menu { position:absolute!important; top:calc(100% + 8px)!important; right:0!important; left:auto!important; margin:0!important; transform:none!important; min-width:180px; z-index:1100; }
.portal-account-dropdown .dropdown-item { width:100%; text-align:left; padding:10px 16px; }
</style>
